/**
 * @description 学期模块
 */
import {
  getCollegeConstructStats,
  getCourseConstructStats,
  getCourseTeacherStats,
  getCourseStudentStats,
} from '@/api/supervision'

const state = () => ({})

const getters = {}
// 同步方法写在这里--对应commit
const mutations = {}
// 异步请求写在这里--对应dispatch
const actions = {
  // 获取学院建设统计情况
  getCollegeConstructStats({}, data) {
    return new Promise((resolve, reject) => {
      getCollegeConstructStats(data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 获取课程建设统计情况
  getCourseConstructStats({}, data) {
    return new Promise((resolve, reject) => {
      getCourseConstructStats(data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 获取课程教师行为统计
  getCourseTeacherStats({}, data) {
    return new Promise((resolve, reject) => {
      getCourseTeacherStats(data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 获取课程学生行为统计
  getCourseStudentStats({}, data) {
    return new Promise((resolve, reject) => {
      getCourseStudentStats(data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
}

export default { state, getters, mutations, actions }
